const localeValues = {
  ko: { clear: "\uAC80\uC0C9\uC5B4 \uCD08\uAE30\uD654" },
  en: { clear: "Clear search keyword" }
};

export { localeValues };
//# sourceMappingURL=locale-values.mjs.map
